<script setup>
defineProps({
  notification: {
    type: Object,
    required: true
  }
});
</script>

<template>
  <div
    class="bg-surface border-l-[5px] rounded-md shadow-[0_2px_4px_rgb(var(--color-shadow)/0.15)] mb-4 p-4 w-[25em] break-words"
    :style="{ borderLeftColor: notification.color }"
  >
    <div class="flex items-center gap-4">
      <font-awesome-icon
        :icon="['fal', notification.icon]"
        class="text-[1.75rem] flex justify-center min-w-8"
        :style="{ color: notification.color }"
      />
      <div class="flex-1">
        <h3 class="m-0 mb-2 text-[1.1rem] text-fg">{{ notification.summary }}</h3>
        <p class="m-0 text-sm text-fg-muted">{{ notification.detail }}</p>
      </div>
    </div>
  </div>
</template>
